(() => {
  const product = document.querySelector('product-info[data-product-id="8788827537736"]');
  if (!product || window.mndjCustomStepsInstalled) return;
  window.mndjCustomStepsInstalled = true;

  const labels = (() => {
    try { return JSON.parse(document.querySelector('#mndj-custom-i18n')?.textContent || '{}'); }
    catch { return {}; }
  })();

  const style = document.createElement('style');
  style.textContent = [
    '#bcpo.mndj-steps-ready{display:block}',
    '#bcpo.mndj-steps-ready>.bcpo-price-addons{display:none}',
    '#bcpo .mndj-step{border:1px solid #d8d8d8;border-radius:8px;margin:0 0 12px;background:#fff}',
    '#bcpo .mndj-step>summary{cursor:pointer;list-style:none;padding:17px 19px;font-weight:650;font-size:calc(var(--font-body-size, 1.6rem) * 1.1);display:flex;align-items:center;justify-content:space-between}',
    '#bcpo .mndj-step>summary::-webkit-details-marker{display:none}',
    '#bcpo .mndj-step>summary:after{content:"+";font-size:calc(var(--font-body-size, 1.6rem) * 1.4);font-weight:400;line-height:1}',
    '#bcpo .mndj-step[open]>summary:after{content:"−"}',
    '#bcpo .mndj-step>summary:focus-visible{outline:2px solid #1a1a1a;outline-offset:2px}',
    '#bcpo .mndj-step-content{padding:0 19px 18px}',
    '#bcpo .mndj-step-content, #bcpo .mndj-step-content label, #bcpo .mndj-step-content legend, #bcpo .mndj-step-content p, #bcpo .mndj-step-content span, #bcpo .mndj-step-content select, #bcpo .mndj-step-content input, #bcpo .mndj-step-content textarea{font-size:var(--font-body-size, 1.6rem);line-height:1.5}',
    '#bcpo .mndj-step-content>.selector-wrapper{margin-bottom:18px}',
    '.mndj-total-label{font-weight:650;margin:16px 0 4px;font-size:var(--font-body-size, 1.6rem)}',
    'body > .mndj-start-cta{display:none}',
    '@media(max-width:767px){body > .mndj-start-cta{display:block;position:fixed;left:12px;right:12px;bottom:calc(12px + env(safe-area-inset-bottom));z-index:40;box-shadow:0 4px 18px rgba(0,0,0,.2)}body:has(#PBarNextFrame) > .mndj-start-cta{bottom:calc(172px + env(safe-area-inset-bottom))}body:has(.mndj-start-cta){padding-bottom:150px}}'
  ].join('');
  document.head.appendChild(style);

  const groups = [
    { title: labels.stepSize || '1. Taille', indices: [0] },
    { title: labels.stepPhotos || '2. Vos photos', indices: [3, 4, 5, 6, 7, 8, 9, 10, 11, 15] },
    { title: labels.stepAccessories || '3. Accessoires', indices: [1, 12, 14] },
    { title: labels.stepLogo || '4. Logo', indices: [2, 13] }
  ];
  let steps = [];
  let installed = false;

  function enhance() {
    if (installed) return;
    const bcpo = product.querySelector('#bcpo');
    if (!bcpo) return;
    const wrappers = [...bcpo.children].filter(node => node.classList.contains('selector-wrapper'));
    if (wrappers.length !== 16) return;
    const labels = wrappers.map(node => node.textContent.trim());
    if (!labels[0].startsWith('Taille de la figurine') ||
        !labels[1].startsWith('Accessoires') ||
        !labels[2].startsWith('Logo sur le t-shirt') ||
        !labels[6].startsWith('Photo de face') ||
        !labels[9].startsWith('Photo 1 des vêtements') ||
        !labels[13].startsWith('Photo du logo')) return;

    installed = true;
    const anchor = bcpo.querySelector('.bcpo-file-check');
    if (!anchor) return;
    steps = groups.map((group, index) => {
      const details = document.createElement('details');
      details.className = 'mndj-step';
      details.dataset.mndjStep = String(index + 1);
      if (index === 0) details.open = true;
      const summary = document.createElement('summary');
      summary.textContent = group.title;
      const content = document.createElement('div');
      content.className = 'mndj-step-content';
      details.append(summary, content);
      bcpo.insertBefore(details, anchor);
      group.indices.forEach(i => content.appendChild(wrappers[i]));
      return details;
    });
    bcpo.classList.add('mndj-steps-ready');

    const price = product.querySelector('[id^="price-"]');
    const priceBlock = price?.parentElement;
    if (price && priceBlock?.classList.contains('product__block--price')) {
      const label = document.createElement('p');
      label.className = 'mndj-total-label';
      label.textContent = labels.total || 'Prix total';
      priceBlock.append(label, price);
    }

    const buyBlock = product.querySelector('.product__block--buy_buttons');
    if (buyBlock && !document.querySelector('body > .mndj-start-cta')) {
      const cta = document.createElement('button');
      cta.type = 'button';
      cta.className = 'btn btn--primary mndj-start-cta';
      cta.textContent = labels.start || 'Commencer ma personnalisation';
      cta.addEventListener('click', () => {
        const active = steps.find(step => step.open) || steps[0];
        active.open = true;
        active.querySelector('summary')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        active.querySelector('summary')?.focus({ preventScroll: true });
      });
      document.body.appendChild(cta);
    }
  }

  const observer = new MutationObserver(() => {
    if (!installed) enhance();
  });
  observer.observe(product, { childList: true, subtree: true });
  enhance();

  window.addEventListener('click', event => {
    if (!installed) return;
    const add = event.target.closest('.product__block--buy_buttons button[type="submit"]');
    if (!add || !product.contains(add)) return;
    const required = [
      'properties[Photo de face (obligatoire)]',
      'properties[Photo 1 des vêtements (obligatoire)]'
    ];
    if (required.some(name => ![...product.querySelectorAll('input[type="file"]')]
      .find(input => input.name === name)?.files?.length)) {
      steps[1].open = true;
    }
  }, true);
})();